import { Button } from '../../../components/ui/button';
import { GalleryBlock, GiftsBlock, LocationBlock, RsvpBlock, SiteFooter, StoryBlock, renderGalleryByPosition } from '../shared/TemplateBlocks';

export default function ModernBlackTieTemplate(props) {
  const {
    site,
    theme,
    weddingDateLabel,
    daysUntil,
    locationCards,
    availableGifts,
    galleryPosition,
    isTemplatePreview,
    onTemplatePreviewRedirect,
    onOpenRsvp,
    onGiftClick,
    onOpenGallery,
    showGiftSection,
    showRsvpCount,
    confirmedGuests
  } = props;

  const galleryNode = (
    <GalleryBlock
      galleryImages={site.gallery_images}
      headingFont={theme.headingFont}
      titleColor={theme.galleryTitleColor || '#F8FAFC'}
      secondaryColor={theme.galleryIconColor || theme.secondaryColor}
      sectionBackground={theme.gallerySectionBackground}
      onOpenGallery={onOpenGallery}
      cardClass="rounded-none"
    />
  );

  return (
    <>
      <section className="relative min-h-[82vh] text-white" style={{ background: theme.bannerSectionBackground || '#0E1117' }}>
        <div className="absolute inset-0 bg-cover bg-center opacity-45" style={{ backgroundImage: `url(${theme.heroImage})` }} />
        <div className="absolute inset-0" style={{ background: theme.heroOverlay, opacity: theme.heroOverlayOpacity }} />
        <div className="relative z-10 mx-auto grid max-w-7xl gap-8 px-6 py-14 md:grid-cols-[1.6fr_0.9fr]">
          <div className="self-end">
            <p className="text-[0.68rem] uppercase tracking-[0.35em]" style={{ color: theme.bannerTextColor || 'rgba(255,255,255,0.6)', fontFamily: theme.bannerTextFont }}>Modern Black Tie</p>
            <h1 className="mt-4 text-5xl md:text-7xl leading-[0.95]" style={{ color: theme.heroTitleColor, fontFamily: theme.bannerTitleFont }}>
              {site.couple_names}
            </h1>
            <p className="mt-4 text-lg" style={{ color: theme.bannerTextColor || 'rgba(255,255,255,0.85)', fontFamily: theme.bannerTextFont }}>{weddingDateLabel}</p>
            <Button
              onClick={() => (isTemplatePreview ? onTemplatePreviewRedirect?.() : onOpenRsvp?.())}
              className="mt-8 rounded-none h-12 px-8 font-semibold"
              style={{ background: theme.confirmButtonBackground, color: theme.confirmButtonText, borderColor: theme.confirmButtonBorder, borderWidth: 1, borderStyle: 'solid' }}
            >
              Confirmar Presença
            </Button>
          </div>

          <aside className="rounded-2xl border border-white/20 bg-black/45 p-6 backdrop-blur-md">
            <p className="text-[0.65rem] uppercase tracking-[0.24em] text-white/60">Status do evento</p>
            <div className="mt-4 space-y-4">
              <div>
                <p className="text-[0.65rem] uppercase tracking-[0.2em] text-white/55">Contagem</p>
                <p className="text-2xl font-semibold">{daysUntil} dias</p>
              </div>
              <div>
                <p className="text-[0.65rem] uppercase tracking-[0.2em] text-white/55">Cerimônia</p>
                <p className="text-sm font-medium">{site.ceremony_time || '--:--'}</p>
                <p className="text-xs text-white/70">{site.ceremony_location || 'Local a confirmar'}</p>
              </div>
              <div>
                <p className="text-[0.65rem] uppercase tracking-[0.2em] text-white/55">Recepção</p>
                <p className="text-sm font-medium">{site.reception_time || '--:--'}</p>
                <p className="text-xs text-white/70">{site.reception_location || 'Local a confirmar'}</p>
              </div>
            </div>
          </aside>
        </div>
      </section>

      {renderGalleryByPosition(galleryPosition, 'after_hero', galleryNode)}

      <LocationBlock
        locationCards={locationCards}
        headingFont={theme.headingFont}
        titleFont={theme.locationTitleFont || theme.headingFont}
        titleColor="#F8FAFC"
        textColor="#D6DAE0"
        textFont={theme.locationTextFont}
        secondaryColor={theme.secondaryColor}
        sectionBackground={theme.locationSectionBackground || '#0F172A'}
        sectionIconColor={theme.locationIconColor || theme.locationTitleColor || theme.secondaryColor}
        cardBackground={theme.locationCardBackground}
        cardIconBackground={theme.locationIconColor || theme.locationTitleColor || theme.secondaryColor}
        cardTitleColor={theme.locationTitleColor || '#F8FAFC'}
        cardLinkColor={theme.locationIconColor || theme.locationTitleColor || theme.secondaryColor}
        cardClass="rounded-none border border-white/10 bg-[#151A22] shadow-none"
        title="Local e programação"
      />

      <StoryBlock
        title="Nossa História"
        storyText={site.story_text}
        background={theme.storySectionBackground || '#11131B'}
        titleColor={theme.storyTitleColor || '#F8FAFC'}
        bodyColor={theme.storyBodyColor || '#D6DAE0'}
        titleFont={theme.storyTitleFont}
        bodyFont={theme.storyBodyFont}
      />

      {renderGalleryByPosition(galleryPosition, 'after_story', galleryNode)}
      {renderGalleryByPosition(galleryPosition, 'before_gifts', galleryNode)}

      <GiftsBlock
        gifts={availableGifts}
        headingFont={theme.headingFont}
        theme={theme}
        titleColor="#F8FAFC"
        textColor="#CBD5E1"
        secondaryColor={theme.secondaryColor}
        onGiftClick={onGiftClick}
        showGiftSection={showGiftSection}
      />

      {renderGalleryByPosition(galleryPosition, 'end', galleryNode)}

      <RsvpBlock
        onOpenRsvp={onOpenRsvp}
        isTemplatePreview={isTemplatePreview}
        onTemplatePreviewRedirect={onTemplatePreviewRedirect}
        primaryColor="#0F172A"
        secondaryColor={theme.secondaryColor}
        sectionBackground={theme.rsvpSectionBackground}
        buttonBackground={theme.confirmButtonBackground}
        buttonText={theme.confirmButtonText}
        buttonBorder={theme.confirmButtonBorder}
        iconColor={theme.rsvpIconColor || theme.rsvpTextColor || theme.bodyTextColor}
        titleColor={theme.rsvpTextColor || theme.bodyTextColor}
        bodyColor={theme.rsvpTextColor || theme.bodyTextColor}
        countColor={theme.rsvpTextColor || theme.bodyTextColor}
        headingFont={theme.rsvpTitleFont || theme.headingFont}
        bodyFont={theme.rsvpTextFont}
        showRsvpCount={showRsvpCount}
        confirmedGuests={confirmedGuests}
      />

      <SiteFooter coupleNames={site.couple_names} textColor="#D6DAE0" />
    </>
  );
}

